export default __webpack_public_path__ + "static/media/icon_warehouse_staff.1ec1ee51.svg";